import { render, staticRenderFns } from "./BadgeActivity.vue?vue&type=template&id=9838ed2e&scoped=true"
import script from "./BadgeActivity.vue?vue&type=script&lang=ts"
export * from "./BadgeActivity.vue?vue&type=script&lang=ts"
import style0 from "./BadgeActivity.vue?vue&type=style&index=0&id=9838ed2e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9838ed2e",
  null
  
)

export default component.exports